import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import HomeComponent from './HomeComponent';

import { homeOperations } from './duck';
import { playerOperations } from '../player/duck';
import { storyboardOperations } from '../storyboard/duck';
import { commonOperations } from '../main-wrapper/duck';
import { enqueueSnackbar } from '../snackbar/duck/actions';

const mapStateToProps = state => ({
  ...state.home,
  ...state.common,
  ...state.storyboard,
});

const mapDispatchToProps = dispatch => {
  const fetchProgramStructure = () => homeOperations.fetchProgramStructure(); // fetch
  const loadProgramStructure = data =>
    dispatch(homeOperations.loadProgramStructureAction(data)); // load
  const fetchProgramData = structure =>
    dispatch(homeOperations.fetchProgramData(structure)); // fetch

  const fetchSearchResult = (searchKeyword, trayName = 'projects') => {
    // search storyboards
    return dispatch(
      homeOperations.fetchSearchedStoryboard(searchKeyword, trayName)
    );
  };

  const getPaginatedData = request => {
    return dispatch(homeOperations.getPaginatedData(request));
  };

  const createStoryboard = (request, type) =>
    storyboardOperations.createStoryboard(request, type);

  const clearData = () => {
    return dispatch(homeOperations.clearData());
  };

  const updatePusherData = (data, trayName, type) => {
    dispatch(homeOperations.updatePusherData(data, trayName, type));
  };

  // to create / update / get / delete specific task
  const createUpdateTask = (request, type) =>
    storyboardOperations.createUpdateTask(request, type);

  const loadSelectedTaskDetails = data =>
    dispatch(storyboardOperations.loadSelectedTask(data));

  // to fetch task types - dropdown menu
  const getTaskTypes = request => storyboardOperations.fetchTaskTypes(request);

  // this will get assign to users based on taskType
  const getAssignToUsers = request =>
    dispatch(storyboardOperations.fetchAssignToUsers(request));

  const toggleSidebar = data => dispatch(commonOperations.sidebarToggle(data));

  // this will create / update task
  const createUpdateFetchTask = (request, method) =>
    storyboardOperations.createUpdateTask(request, method);

  // Snackbar toast
  const toggleToast = data => dispatch(enqueueSnackbar(data));

  // to toggle upgrade modal
  const toggleUpgradeModal = data =>
    dispatch(commonOperations.upgradeModalAction(data));

  const verifySharedAsset = (request, method) =>
    playerOperations.verifySharedAsset(request, method);

  const toggleAssignedTaskFromHome = data =>
    dispatch(storyboardOperations.loadAssignedTaskFromHome(data));

  const loadProgramData = data =>
    dispatch(homeOperations.loadProgramTrays(data)); // load

  return {
    fetchSearchResult,
    createStoryboard,
    clearData,
    updatePusherData,
    createUpdateTask,
    loadSelectedTaskDetails,
    getAssignToUsers,
    getTaskTypes,
    getPaginatedData,
    toggleSidebar,
    createUpdateFetchTask,
    toggleToast,
    toggleUpgradeModal,
    fetchProgramStructure,
    fetchProgramData,
    loadProgramStructure,
    verifySharedAsset,
    toggleAssignedTaskFromHome,
    loadProgramData,
  };
};

const HomeContainer = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HomeComponent)
);

export default HomeContainer;
